import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';

export const unauthorizedInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const hadAuthHeader = req.headers.has('Authorization');

  return next(req).pipe(
    catchError((error: unknown) => {
      if (
        hadAuthHeader &&
        error instanceof HttpErrorResponse &&
        error.status === 401
      ) {
        authService.logout();
      }
      return throwError(() => error);
    }),
  );
};
